<template>
  <div
    class="bannerBox"
    :style="{
      backgroundImage: 'url(' + bgSrc + ')',
      backgroundPosition: isMobile ? 'center -40%' : 'center center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      padding: isMobile ? '2.44rem 0' : padding,
      position: 'relative',
    }"
  >
    <div class="mainContent">
      <div class="title1">为什么选择我们？</div>
      <div class="desc">支持企业跨境出海，和有语言障碍的外国友人实时交流</div>
      <div class="desc">支持多种即时通讯交流软件，支持全球大部分语种</div>
      <div class="desc">即时交流无需复制粘贴，自动翻译，畅享极速交流体验</div>
      <div
        class="downloadBtn cursor-pointer inline-block"
        @click="toOtherAnchor"
      >
        立即下载
      </div>
      <div class="downloadBtn cursor-pointer inline-block" @click="register">
        免费试用
      </div>
    </div>
  </div>
</template>
<script>
import bannerBg from "@/assets/imgs/index/banner.png";
export default {
  props: {
    showCarousel: {
      type: Boolean,
      default: false,
    },
    title1: {
      type: String,
      default: "易翻译",
    },
    title2: {
      type: String,
      default: "电商客服辅助翻译平台",
    },
    desc: {
      type: String,
      default: "专业、快捷、高效的翻译软件",
    },
    showDownload: {
      type: Boolean,
      default: true,
    },
    showValid: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
      default: "7.9375rem 0 12.9375rem",
    },
  },
  data() {
    const isMobile =
      window.screen.width > 768 || window.screen.width == 768 ? false : true;
    return {
      bgSrc: bannerBg,
      isMobile,
    };
  },
  methods: {
    toOtherAnchor() {
      this.$emit("toOtherAnchor", { anchor: "download" });
    },
    register() {
      if (this.$route.query.inviteCode) {
        this.$router.push({
          path: "/login",
          query: { type: 2, inviteCode: this.$route.query.inviteCode },
        });
      } else {
        this.$router.push({ path: "/login", query: { type: 2 } });
      }
    },
  },
};
</script>
<style scoped>
.carousel {
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
}
.PCImg {
  position: absolute;
  right: 20%;
  top: 22%;
  height: 350px;
  width: auto;
}
.mainContent {
  position: relative;
  z-index: 999;
}
.title1,
.title2 {
  color: #2c3e50;
  font-size: 2.1875rem;
  font-weight: 600;
  line-height: 3rem;
  text-align: left;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.title2 {
  margin-top: 0.5rem;
}
.desc {
  font-size: 1.25rem;
  line-height: 1.375rem;
  text-align: left;
  color: #34495e;
  margin: 1.625rem 0 2.25rem;
  font-weight: bolder;
}
.downloadBtn {
  line-height: 1.1875rem;
  text-align: center;
  background: linear-gradient(180deg, #5192fd 0%, #1d6ced 100%);
  padding: 0.875rem 1.75rem;
  border-radius: 0.5rem;
  color: var(--vt-c-white);
  margin-right: 12px;
}
@media (max-width: 768px) {
  .bannerBox {
    height: 22.5rem;
  }
  .mainContent {
    text-align: center;
  }

  .PCImg {
    position: absolute;
    right: calc(50% - 100px);
    top: 35%;
    width: 200px;
    height: auto;
  }
  .title1 {
    color: #000;
    text-align: center;
    font-family: Inter;
    font-size: 1.375rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .desc {
    color: #042967;
    font-family: Inter;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 0.65rem;
    text-align: center;
  }
}
</style>
<style>
.bannerBox .el-carousel__container {
  height: 100%;
}
.bannerBox .el-carousel__indicators--horizontal {
  bottom: 70px;
}
.bannerBox .el-carousel__indicator--horizontal button {
  height: 8px;
  width: 8px;
  border-radius: 16px;
  opacity: 1;
}

.bannerBox .el-carousel__indicator--horizontal.is-active button {
  background: #2470ef;
  width: 26px;
}
</style>